/**
 * Format date string (YYYY-MM-DD) to MM/DD format
 * Avoids timezone offset issues by parsing manually
 * @param {string} dateStr - Date string in YYYY-MM-DD format
 * @returns {string} Formatted date in MM/DD format
 */
export const formatDateMMDD = (dateStr) => {
    try {
        const [year, month, day] = dateStr.split("-");
        if (!year || !month || !day) return "";
        return `${String(month).padStart(2, "0")}/${String(day).padStart(2, "0")}`;
    } catch (e) {
        return "";
    }
};

/**
 * Format date string (YYYY-MM-DD) to MM/DD/YY format
 * Avoids timezone offset issues by parsing manually
 * @param {string} dateStr - Date string in YYYY-MM-DD format
 * @returns {string} Formatted date in MM/DD/YY format
 */
export const formatDateMMDDYY = (dateStr) => {
    try {
        const [year, month, day] = dateStr.split("-");
        if (!year || !month || !day) return "";
        return `${String(month).padStart(2, "0")}/${String(day).padStart(2, "0")}/${String(year).slice(-2)}`;
    } catch (e) {
        return "";
    }
};

/**
 * Parse the string value from DateRangeContext into a numeric lookback window
 * @param {string|number} val 
 * @returns {number}
 */
export const getLookbackDays = (val) => {
    if (!val) return 30;
    if (!isNaN(Number(val))) return Number(val);
    if (val === "YTD") return 365;
    if (val === "ALL") return 1000; // Large number for full history
    return 30;
};